import React, { useEffect, useState } from "react";
import { InputField, SelectField } from ".././FormFields";

export default function CurrencyForm({ initialData, onSubmit }) {
  const [form, setForm] = useState({
    code: "",
    symbol: "",
    title: "",
    status: "active",
  });

  useEffect(() => {
    if (initialData) {
      setForm({
        code: initialData.code || "",
        symbol: initialData.symbol || "",
        title: initialData.title || "",
        status: initialData.status || "active",
      });
    }
  }, [initialData]);

  const submit = (e) => {
    e.preventDefault();

    onSubmit({
      code: form.code.toUpperCase(),
      symbol: form.symbol,
      title: form.title,
      status: form.status,
    });
  };

  return (
    <form onSubmit={submit} className="flex flex-col gap-3">
      <InputField
        label="Currency Code"
        name="code"
        value={form.code}
        onChange={(e) => setForm({ ...form, code: e.target.value })}
        placeholder="USD"
        required
      />
      {/* <div>
        <label className="mb-1 block text-sm font-medium">
          Currency Code<span className="text-red-500">*</span>
        </label>
        <input
          className="w-full rounded border p-2 uppercase"
          placeholder="USD"
          value={form.code}
          onChange={(e) =>
            setForm({ ...form, code: e.target.value })
          }
          required
        />
      </div> */}
      <InputField
        label="Symbol"
        name="symbol"
        value={form.symbol}
        onChange={(e) => setForm({ ...form, symbol: e.target.value })}
        placeholder="$"
        required
      />
      {/* <div>
        <label className="mb-1 block text-sm font-medium">
          Symbol<span className="text-red-500">*</span>
        </label>
        <input
          className="w-full rounded border p-2"
          placeholder="$"
          value={form.symbol}
          onChange={(e) => setForm({ ...form, symbol: e.target.value })}
          required
        />
      </div> */}

      <InputField
        label="Title"
        name="title"
        value={form.title}
        onChange={(e) => setForm({ ...form, title: e.target.value })}
        placeholder="US Dollar"
        required
      />

      {/* <div>
        <label className="mb-1 block text-sm font-medium">
          Title<span className="text-red-500">*</span>
        </label>
        <input
          className="w-full rounded border p-2"
          placeholder="US Dollar"
          value={form.title}
          onChange={(e) => setForm({ ...form, title: e.target.value })}
          required
        />
      </div> */}
      <SelectField
        label="Status"
        name="status"
        value={form.status}
        onChange={(e) => setForm({ ...form, status: e.target.value })}
        options={[
          { label: "active", value: "Active" },
          { label: "inactive", value: "Inactive" },
        ]}
        placeholder="Search status..."
      />

      {/* <div>
        <label className="mb-1 block text-sm font-medium">Status</label>
        <select
          className="w-full rounded border p-2"
          value={form.status}
          onChange={(e) => setForm({ ...form, status: e.target.value })}
        >
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div> */}
      <div className="mt-4 flex justify-end">
        <button className="btn-primary">
          {initialData ? "Update" : "Save"}
        </button>
      </div>
    </form>
  );
}
